var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.id,"title":_vm.title,"ok-title":_vm.title,"header-bg-variant":"danger","header-text-variant":"light","ok-variant":"danger"},on:{"hidden":_vm.cancelDeletion,"ok":_vm.confirmDeletion}},[_c('p',[_vm._v("Вы "+_vm._s(_vm.removeWord)+" "),_vm._t("default"),_vm._v(". Вы уверены?")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }